import { createStore } from 'vuex';
import axios from 'axios';

// API_URL'i düzelt
const API_URL = '/api';

const api = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  withCredentials: false
});

export default createStore({
  state: {
    user: JSON.parse(localStorage.getItem('user')) || null,
    token: localStorage.getItem('token') || null,
    authInitialized: false,
    isMobile: false,
    sidebarVisible: false,
    apiError: null
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
      if (user) {
        localStorage.setItem('user', JSON.stringify(user));
      } else {
        localStorage.removeItem('user');
      }
    },
    SET_TOKEN(state, token) {
      state.token = token;
      if (token) {
        localStorage.setItem('token', token);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      } else {
        localStorage.removeItem('token');
        delete api.defaults.headers.common['Authorization'];
      }
    },
    SET_AUTH_INITIALIZED(state) {
      state.authInitialized = true;
    },
    SET_MOBILE(state, isMobile) {
      state.isMobile = isMobile;
    },
    SET_SIDEBAR_VISIBLE(state, visible) {
      state.sidebarVisible = visible;
    },
    TOGGLE_SIDEBAR(state) {
      state.sidebarVisible = !state.sidebarVisible;
    },
    SET_API_ERROR(state, error) {
      state.apiError = error;
    }
  },
  actions: {
    async login({ commit }, credentials) {
      try {
        console.log('Login attempt to:', '/auth/login');
        const response = await api.post('/auth/login', credentials);
        const { token, user } = response.data;
        
        commit('SET_TOKEN', token);
        commit('SET_USER', user);
        commit('SET_AUTH_INITIALIZED');
        commit('SET_API_ERROR', null);
        
        return { success: true };
      } catch (error) {
        console.error('Login error:', error);
        
        let errorMessage = 'Giriş başarısız';
        if (error.response) {
          errorMessage = error.response.data?.error || `HTTP ${error.response.status}`;
        } else if (error.request) {
          errorMessage = 'Sunucuya bağlanılamadı';
        } else {
          errorMessage = error.message;
        }
        
        commit('SET_API_ERROR', errorMessage);
        return { 
          success: false, 
          error: errorMessage 
        };
      }
    },
    
    logout({ commit }) {
      commit('SET_TOKEN', null);
      commit('SET_USER', null);
      commit('SET_AUTH_INITIALIZED');
      commit('SET_API_ERROR', null);
    },
    
    async initializeAuth({ commit, dispatch }) {
      const token = localStorage.getItem('token');
      const user = JSON.parse(localStorage.getItem('user'));
      
      if (token && user) {
        try {
          api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          await api.get('/test');
          commit('SET_TOKEN', token);
          commit('SET_USER', user);
          commit('SET_API_ERROR', null);
        } catch (error) {
          console.error('Token validation failed:', error);
          commit('SET_API_ERROR', 'Oturum doğrulanamadı');
          dispatch('logout');
        }
      } else {
        dispatch('logout');
      }
      
      commit('SET_AUTH_INITIALIZED');
    }
  },
  getters: {
    isAuthenticated: state => !!state.token,
    userRole: state => state.user?.role,
    userName: state => state.user?.name,
    userId: state => state.user?.id,
    userEmail: state => state.user?.email,
    userPhone: state => state.user?.phone,
    authInitialized: state => state.authInitialized,
    isMobile: state => state.isMobile,
    sidebarVisible: state => state.sidebarVisible,
    apiError: state => state.apiError
  }
});